var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"600px","width":"800px"},attrs:{"id":"chartChinaMap"}})}
var staticRenderFns = []

export { render, staticRenderFns }